import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from 'react-to-print';
import Modal from "./interface/Modal";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import { ContentsDtoWithId, DynamicProgramDto, LayoutDto, ProgramDto } from "../types/dto";
import { useQuery } from "@tanstack/react-query";
import { getSchedules } from "../services/schedule";
import { getContentsByIds } from "../services/contents";
import { SequenceMemoItem, getSequenceMemo } from "../services/sequenceMemo";
import { cls } from "../libs/utils";
import { Part, Tool } from "../types/models";
import LayoutTableItem from "../pages/Admin/Layout/LayoutTableItem";

interface ScheduleExcelProps {
  //--> 휴대폰 전용 화면. 표 대신 폰 폭에 맞는 카드로 이어서 그린다.
  mobileView?: boolean;
  showPrint?: boolean;
}

export default function ScheduleExcel({
  mobileView = false,
  //--> 인쇄 기능은 막아둔 상태. 다시 열려면 이 기본값을 true 로.
  showPrint = false,
}: ScheduleExcelProps) {
  const { date } = useParams();

  //--> brandId 가져오기
  const location = useLocation();
  const queryString = location.search;
  const params = new URLSearchParams(queryString);
  const brandId = params.get("brandId")

  const componentRef: any = useRef();
  const handlePrint = useReactToPrint({content: () =>{return componentRef.current as any}});

  const [programDataList, setProgramDataList] = useState<ProgramDto[]>();
  const [dynamicProgramDataList, setDynamicProgramDataList] = useState<DynamicProgramDto[]>();
  const [layoutDataList, setLayoutDataList] = useState<LayoutDto[]>();
  
  const [videoUrl, setVideoUrl] = useState<string>();
  

  const { data:scheduleData } = useQuery<any, Error>(["getSchedules"], () =>getSchedules(date || '', date || '', Number(brandId)) );
  
  useEffect(() => {
    getProgram()
  }, [scheduleData]);

  const getProgram = async ()=>{
    //--> 프로그램에 필요한 정보 받아서 정리
    if(scheduleData && scheduleData[date || ""])
    {
      const scheduleProgramList = scheduleData[date || ""]

      let programIds = scheduleProgramList.map((item:any)=>{ return item.id})
      const programsimpleRes = await axios.get(`${process.env.REACT_APP_SERVER_URL}api/public/programsimple`, { withCredentials: true, params:{ids:programIds.toString()} });
      
      const _programDataList = []
      const _dynamicProgramDataList = []
      const _layoutDataList = []
      if(programsimpleRes && programsimpleRes.data) {
        for (let i = 0; i < programsimpleRes.data.length; i++) {
          const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}api/public/dynamicprogram/${programsimpleRes.data[i].id}`, { withCredentials: true });
          if(programsimpleRes.data[i].actionType == 1) {
            _programDataList.push(response.data)
          }
          else
          {
            console.log('response.data : ', response.data)
            const layoutresponse = await axios.get(`${process.env.REACT_APP_SERVER_URL}api/public/layout/${response.data.program.layoutId}`, { withCredentials: true });
            _layoutDataList.push(layoutresponse.data)
            _dynamicProgramDataList.push(response.data)
            
          }
        }
      }

      setProgramDataList(_programDataList)
      setDynamicProgramDataList(_dynamicProgramDataList)
      setLayoutDataList(_layoutDataList)
    }
  }

  //--> 카디오 정보 보기( 있는 경우 만)
  const getProgramCadioList = (item:any)=>{
    console.log('item.cadioStrength : ', item.cadioStrength)
    if(!item.cadioStrength) {
      return []
    }
    const strengthList = JSON.parse(item.cadioStrength)

    if(item.programType != '본운동')
    {
      return []
    }
    
    let result = []
    if(strengthList.length > 2)
    {
      let color = 'FREE'
      for (let j = 0; j < strengthList[0].length; j++) {
        const loopList = [strengthList[0][j], strengthList[1][j], strengthList[2][j]]
        for (let k = 0; k < loopList.length; k++) {
          color = 'FREE'
          for (let l = 0; l < loopList[k].length; l++) {
            if(loopList[k][l] == 'ROLL-UP' && color == 'FREE')
            {
              color = 'ROLL-UP'
            }
            
            if(loopList[k][l] == 'ALL-OUT')
            {
              color = 'ALL-OUT'
            }
          }
          result.push(color)
          result.push(color)
        }
      }
    }
    
    return result
  }

  //--> 툴 정보
  const getToolsFromProgram = (program:ProgramDto)=>{
    const tool1s = extractTools(program.zone1Data)
    const tool2s = extractTools(program.zone2Data)
    const tool3s = extractTools(program.zone3Data)

    const toolNames = Array.from(
      new Set([...tool1s, ...tool2s, ...tool3s])
    );

    if(toolNames)
    {
      return toolNames.join(',')
    }

    return
  }
  const getToolsFromDynamicProgram = (program:DynamicProgramDto)=>{
    const tools = extractTools(program.content)

    const toolNames = Array.from(
      new Set([...tools])
    );

    if(toolNames)
    {
      return toolNames.join(',')
    }

    return
  }
  
  //--> 파트 정보
  const getPartsFromProgram = (program:ProgramDto)=>{
    const part1s = extractParts(program.zone1Data)
    const part2s = extractParts(program.zone2Data)
    const part3s = extractParts(program.zone3Data)

    const partNames = Array.from(
      new Set([...part1s, ...part2s, ...part3s])
    );

    if(partNames)
    {
      return partNames.join(',')
    }

    return
  }
  const getPartsFromDynamicProgram = (program:DynamicProgramDto)=>{
    const parts = extractParts(program.content)

    const partNames = Array.from(
      new Set([...parts])
    );

    if(partNames)
    {
      return partNames.join(',')
    }

    return
  }

  //--> 시간 정보
  const getDynamicProgramTime = (program:DynamicProgramDto)=>{
    let _exerciseTime = program.program.exerciseTime
    let _moveTime = program.program.moveTime

    if(_exerciseTime == 0) {
      const _exerciseTimes = program.program.exerciseTimes.split(',')
      if(_exerciseTimes.length > 0) {
        _exerciseTime = parseInt(_exerciseTimes[0])
      }
    }
    if(_moveTime == 0) {
      const _moveTimes = program.program.moveTimes.split(',')
      if(_moveTimes.length > 0) {
        _moveTime = parseInt(_moveTimes[0])
      }
    }

    return `${_exerciseTime}/${_moveTime}`
  }

  //--> 옵션 정보
  const getDynamicProgramOption = (program:DynamicProgramDto)=>{
    let result = ''
    if(layoutDataList && (layoutDataList.length > 0)) {
      for (let i = 0; i < layoutDataList.length; i++) {
        if(layoutDataList[i].id == program.program.layoutId) {
          result = layoutDataList[i].optionType == 'team'?'팀로테이션':'전체로테이션'
          if(layoutDataList[i].optionType == 'team'){
            result += `/${layoutDataList[i].optionTeamCount}팀`
      
            if(layoutDataList[i].optionTeamRotate == 1) {
              result += `/팀교대`
            }
          }
          if(layoutDataList[i].optionMission == 1) {
            result += `/미션`
          }
          if(layoutDataList[i].optionOver == 1) {
            result += `/OVER`
          }
          if(layoutDataList[i].optionAdd == 1) {
            result += `/ADD`
          }
          if(layoutDataList[i].optionWod == 1) {
            result += `/WOD`
          }
          return result
        }
        
      }
    }

    return result
  }
  
  //--> 레이아웃 수
  const getDynamicProgramLayoutCount = (program:DynamicProgramDto)=>{
    if(layoutDataList && (layoutDataList.length > 0)) {
      for (let i = 0; i < layoutDataList.length; i++) {
        if(layoutDataList[i].id == program.program.layoutId) {
          return layoutDataList[i].totalCount
        }
      }
    }
    return 0
  }
  
  //--> 추가운동
  const getDynamicProgramAddProgram = (program:DynamicProgramDto)=>{
    if(program.program.addPrograms) {
      let addprogram = JSON.parse(program.program.addPrograms)

      let result = `${addprogram.length}회 (`

      for (let i = 0; i < addprogram.length; i++) {
        if(i != 0) {
          result += ', '
        }
        result += `${addprogram[i].set}set`
      }
      result += `)`

      return result;
    }

    return '없음'
  }
  
  //--> 물먹는 시간 정보
  const getDynamicProgramWater = (program:DynamicProgramDto)=>{
    if(program.program.waterTimes) {
      let waterTimes = JSON.parse(program.program.waterTimes)

      let result = `${waterTimes.length}회 (`

      for (let i = 0; i < waterTimes.length; i++) {
        if(i != 0) {
          result += ', '
        }
        result += `${waterTimes[i].set}set ${waterTimes[i].time}초`
      }
      result += `)`

      return result;
    }
    
    return '없음'
  }
  
  //--> 레이아웃 정보
  const getDynamicProgramLayout = (program:DynamicProgramDto)=>{
    if(layoutDataList && (layoutDataList.length > 0)) {
      for (let i = 0; i < layoutDataList.length; i++) {
        if(layoutDataList[i].id == program.program.layoutId) {
          return layoutDataList[i]
        }
      }
    }
    return null
  }

  //--> 툴 정보
  const getToolsFromContent = (content:ContentsDtoWithId)=>{
    const toolNames = Array.from( new Set( content.tools.map((tool: Tool) => tool.name).flat() ) )
    
    return toolNames
  }

  //--> 파트 정보
  const getPartsFromContent = (content:ContentsDtoWithId)=>{
    const partNames = Array.from( new Set( content.parts.map((part: Part) => part.name).flat() ) )
    
    return partNames
  }

  //--> 툴 정보
  const extractTools = (arr: ContentsDtoWithId[]) => {
    const toolNames = Array.from(
      new Set(
        arr
          .map((item: ContentsDtoWithId) =>
            item.tools.map((tool: Tool) => tool.name)
          )
          .flat()
      )
    );

    return toolNames;
  };

  //--> 파트 정보
  const extractParts = (arr: ContentsDtoWithId[]) => {
    const partNames = Array.from(
      new Set(
        arr
          .map((item: ContentsDtoWithId) =>
            item.parts.map((part: Part) => part.name)
          )
          .flat()
      )
    );

    return partNames;
  };

  //--> 컨텐츠 정보 불러오기
  const getContent = (program:ProgramDto, contentId:number)=>{
    let result = program.zone1Data.filter((_content:ContentsDtoWithId)=>_content.content.id == contentId)

    if(result && result.length > 0)
    {
      return result[0]
    }
    result = program.zone2Data.filter((_content:ContentsDtoWithId)=>_content.content.id == contentId)

    if(result && result.length > 0)
    {
      return result[0]
    }
    result = program.zone3Data.filter((_content:ContentsDtoWithId)=>_content.content.id == contentId)

    if(result && result.length > 0)
    {
      return result[0]
    }
    
    return null
  }

  const openVideoModal = (item: ContentsDtoWithId) => {
    if (!item.content.videoUrl) {
      return;
    }
    setVideoUrl(item.content.videoUrl);
    //@ts-ignore
    window.videoModal.showModal();
  };

  //--> 큐카드 스텝 영상은 프로그램 응답에 안 실려오므로 id로 따로 가져온다.
  const [qcardContentsById, setQcardContentsById] = useState<{ [id: string]: any }>({});

  //--> 프로그램의 content JSON 에서 큐카드만 꺼낸다. { "동작콘텐츠id": [{id, type}, ...] }
  const readQcard = (program: any) => {
    try {
      const parsed = JSON.parse(program.content || '{}');
      return parsed && parsed.qcard ? parsed.qcard : null;
    } catch (error) {
      return null;
    }
  };

  const readQcardStep = (v: any) => {
    //--> 타입 붙기 전 옛 데이터(숫자 id만)도 읽는다.
    if (v && typeof v == 'object') return { id: Number(v.id), type: v.type || '애드온' };
    return { id: Number(v), type: '애드온' };
  };

  useEffect(() => {
    if (!mobileView) return;

    const ids: number[] = [];
    (dynamicProgramDataList || []).forEach((item: DynamicProgramDto) => {
      const qcard = readQcard(item.program);
      if (!qcard) return;
      Object.keys(qcard).forEach((mainId: string) => {
        (qcard[mainId] || []).forEach((v: any) => ids.push(readQcardStep(v).id));
      });
    });

    const uniqueIds = Array.from(new Set(ids)).filter((id: number) => !!id);
    if (uniqueIds.length == 0) {
      setQcardContentsById({});
      return;
    }

    let canceled = false;
    getContentsByIds(uniqueIds.join(','), false)
      .then((rows: any[]) => {
        if (canceled) return;
        const byId: { [id: string]: any } = {};
        (rows || []).forEach((r: any) => {
          //--> 이 API 는 DB 원본(snake_case)을 그대로 주므로 화면에서 쓰는 형태로 맞춘다.
          byId[r.id] = {
            content: {
              ...r,
              thumbnailUrl: r.thumbnail_url,
              videoUrl: r.video_url,
              videoFileType: r.video_file_type,
            },
            parts: [],
            tools: [],
          };
        });
        setQcardContentsById(byId);
      })
      .catch((error) => {
        console.log(error);
      });

    return () => {
      canceled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileView, dynamicProgramDataList]);

  //--> 동작 목록을 큐카드 순서대로 편다. Step1 = 동작 자체, 그 뒤로 애드온/빌드업.
  const expandWithQcard = (program: any, contents: ContentsDtoWithId[]) => {
    const qcard = readQcard(program);
    const list: any[] = [];

    contents.forEach((contentItem: ContentsDtoWithId, motionIndex: number) => {
      //--> 실제로 그려질 다음 동작만 센다 (영상 정보를 못 불러온 건 제외)
      const rawSteps = qcard ? (qcard[contentItem.content.id] || []) : [];
      const nextSteps = rawSteps
        .map((v: any) => readQcardStep(v))
        .filter((step: any) => !!qcardContentsById[step.id]);

      const main: any = {
        item: contentItem,
        motionNo: motionIndex + 1,
        stepNo: 1,
        stepType: '기본동작',
        nextCount: nextSteps.length,
        //--> 다음 동작에 어떤 종류가 섞여 있는지 (애드온 / 빌드업)
        nextTypes: Array.from(new Set(nextSteps.map((step: any) => step.type))),
      };
      list.push(main);

      nextSteps.forEach((step: any, i: number) => {
        list.push({
          item: qcardContentsById[step.id],
          motionNo: motionIndex + 1,
          stepNo: i + 2,
          stepType: step.type,
        });
      });
    });

    return list;
  };

  //--> 휴대폰 화면에 그릴 프로그램 목록. 하나씩 이어서 스크롤로 본다.
  const buildMobileProgramList = () => {
    const list: any[] = [];

    const push = (item: any, isDynamic: boolean, contents: ContentsDtoWithId[]) => {
      list.push({
        item: item,
        isDynamic: isDynamic,
        //--> 큐카드가 있으면 스텝까지 편 목록이 실제로 보여줄 영상 목록이 된다.
        steps: expandWithQcard(item.program, contents),
        motionCount: contents.length,
      });
    };

    (dynamicProgramDataList || []).forEach((item: DynamicProgramDto) => {
      push(item, true, (item.content || []).filter(Boolean));
    });

    (programDataList || []).forEach((item: ProgramDto) => {
      const ids = item.program.contentsIds ? item.program.contentsIds.split(',') : [];
      const contents = ids
        .map((id: string) => getContent(item, parseInt(id)))
        .filter(Boolean) as ContentsDtoWithId[];
      push(item, false, contents);
    });

    return list;
  };

  const mobilePrograms = mobileView ? buildMobileProgramList() : [];

  //--> 디바큐잉 메모. 프로그램별로 { "동작콘텐츠id": { memo, 입력자/수정자 } }. 모두가 같은 내용을 본다.
  type MemoMap = { [contentsId: string]: SequenceMemoItem };
  const [memoByProgram, setMemoByProgram] = useState<{ [programId: string]: MemoMap }>({});

  useEffect(() => {
    if (!mobileView) return;

    const ids: number[] = [];
    (dynamicProgramDataList || []).forEach((item: DynamicProgramDto) => ids.push(item.program.id));
    (programDataList || []).forEach((item: ProgramDto) => ids.push(item.program.id));
    if (ids.length == 0) return;

    let canceled = false;
    Promise.all(
      ids.map((id: number) =>
        getSequenceMemo(id)
          .then((memo) => ({ id, memo }))
          //--> 테이블 배포 전이면 실패한다. 메모만 비어 있고 나머지 화면은 그대로 보여준다.
          .catch(() => ({ id, memo: {} as MemoMap }))
      )
    ).then((rows) => {
      if (canceled) return;
      const next: { [programId: string]: MemoMap } = {};
      rows.forEach((r) => { next[r.id] = r.memo || {}; });
      setMemoByProgram(next);
    });

    return () => { canceled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileView, dynamicProgramDataList, programDataList]);

  const getMemo = (programId: number, contentsId: number): SequenceMemoItem | undefined =>
    (memoByProgram[programId] || {})[contentsId];

  //--> 추천 플레이리스트는 bpmInfo 에 '|' 로 이어 붙여 저장한다. (옛 데이터는 줄바꿈으로 저장돼 있어 같이 받아준다)
  const readPlaylist = (program: any): string[] => {
    const raw = program && program.bpmInfo ? `${program.bpmInfo}` : '';
    return raw
      .split(/\||\r?\n/)
      .map((line: string) => line.trim())
      .filter((line: string) => line.length > 0);
  };

  const overviewTools = (page: any) =>
    page.isDynamic ? getToolsFromDynamicProgram(page.item) : getToolsFromProgram(page.item);

  if (mobileView) {
    if (mobilePrograms.length == 0) {
      return (
        <div className="flex h-full items-center justify-center p-10 text-sm text-gray-400">
          이 날짜에 등록된 프로그램이 없습니다.
        </div>
      );
    }

    return (
      <>
        <Modal id="videoModal" title={`영상`}>
          <video src={videoUrl} className="border mt-5" controls />
        </Modal>

        <div className="min-h-full bg-[#f0f0f3] p-3">
          {mobilePrograms.map((entry: any) => {
            const program = entry.item.program;
            //--> 개요는 본운동만. 준비운동·마무리운동 등은 영상 목록만 보여준다.
            const showOverview = program.programType == '본운동';
            const tools = overviewTools(entry);
            const playlist = readPlaylist(program);

            return (
              <div className="mb-6 last:mb-0">
                <div className="mb-3 flex items-baseline px-1">
                  <div className="flex min-w-0 grow items-baseline space-x-2 text-lg font-bold leading-tight">
                    <span className="shrink-0 text-seq-accent">{program.programType}</span>
                    <span className="truncate text-seq-text">{program.name}</span>
                  </div>
                  {program.bpm > 0 && (
                    <span className="ml-2 shrink-0 inline-flex items-baseline space-x-1.5 rounded-full bg-seq-soft px-2.5 py-0.5 text-xs font-bold text-seq-accent">
                      <span className="tracking-wider">BPM</span>
                      <span className="tabular-nums">{program.bpm}</span>
                    </span>
                  )}
                </div>

                {showOverview && (
                  <div className="mb-3 space-y-3">
                    {program.comment && (
                      <div className="overflow-hidden rounded-[14px] border border-seq-border bg-white shadow-[0_1px_2px_rgba(18,18,22,0.05)]">
                        <div className="border-b border-seq-borderSoft px-4 py-2.5 text-sm font-bold text-seq-text">
                          전체 시퀀스 설명
                        </div>
                        <div className="px-4 py-3 text-sm leading-relaxed text-seq-text2">
                          {program.comment}
                        </div>
                      </div>
                    )}

                    {tools && (
                      <div className="overflow-hidden rounded-[14px] border border-seq-border bg-white shadow-[0_1px_2px_rgba(18,18,22,0.05)]">
                        <div className="border-b border-seq-borderSoft px-4 py-2.5 text-sm font-bold text-seq-text">
                          필요 소도구
                        </div>
                        <div className="flex flex-wrap gap-1.5 px-4 py-3">
                          {`${tools}`.split(',').map((tool: string) => (
                            <span className="rounded-full bg-seq-surface2 px-2.5 py-1 text-xs text-seq-text2">
                              {tool.trim()}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    {playlist.length > 0 && (
                      <div className="overflow-hidden rounded-[14px] border border-seq-border bg-white shadow-[0_1px_2px_rgba(18,18,22,0.05)]">
                        <div className="border-b border-seq-borderSoft px-4 py-2.5 text-sm font-bold text-seq-text">
                          추천 플레이리스트
                        </div>
                        <ul>
                          {playlist.map((track: string, i: number) => (
                            <li className={cls(
                              "flex items-center space-x-3 border-b border-seq-borderSoft px-4 py-2.5 last:border-b-0",
                              i == 0 ? "bg-seq-tint" : ""
                            )}>
                              <span className={cls(
                                "w-3.5 shrink-0 text-xs font-bold tabular-nums",
                                i == 0 ? "text-seq-accent" : "text-seq-text3"
                              )}>
                                {i + 1}
                              </span>
                              <span className="grow break-words text-sm text-seq-text2">{track}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}

                <div className="space-y-2.5">
                  {entry.steps.map((step: any) => {
                    const contentItem = step.item;
                    const meta = [getToolsFromContent(contentItem), getPartsFromContent(contentItem)]
                      .filter(Boolean)
                      .join(' · ');
                    const isMain = step.stepNo == 1;
                    return (
                      //--> 시안의 시퀀스 행: 번호 + 썸네일 + (애드온/빌드업) 뱃지 + 이름 + 디바큐잉
                      <div className={cls(
                        isMain
                          ? "rounded-[14px] border border-seq-border bg-white p-3 shadow-[0_1px_2px_rgba(18,18,22,0.05)]"
                          : "ml-5 rounded-[9px] bg-seq-surface2 p-3"
                      )}>
                        {/* 머리줄: 번호 / 종류 / 다음 동작 */}
                        <div className="mb-2 flex items-center space-x-2">
                          {isMain ? (
                            //--> 큐카드(다음 동작)가 있는 동작은 번호에 음영을 줘서 한눈에 구분되게
                            <span className={cls(
                              "flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold tabular-nums",
                              step.nextCount > 0
                                ? "bg-seq-accent text-white"
                                : "text-seq-text3"
                            )}>
                              {`0${step.motionNo}`.slice(-2)}
                            </span>
                          ) : (
                            <span className="shrink-0 text-xs font-bold tracking-wider text-seq-text3">
                              STEP {step.stepNo}
                            </span>
                          )}
                          {/* 시안 .kind — 종류 뱃지는 항상 accent 색 */}
                          <span className="shrink-0 rounded-full bg-seq-soft px-2.5 py-0.5 text-xs font-bold text-seq-accent">
                            {step.stepType}
                          </span>
                          {isMain && (
                            <span className={cls(
                              "grow truncate text-right text-xs font-bold",
                              step.nextCount > 0 ? "text-seq-accent" : "text-seq-text3"
                            )}>
                              {step.nextCount > 0
                                ? `다음 동작 ${step.nextCount}개`
                                : '다음 동작 없음'}
                            </span>
                          )}
                        </div>

                        {/* 왼쪽 영상 / 오른쪽 글. 이름은 잘리지 않고 줄바꿈된다 */}
                        <div className="flex items-start space-x-3">
                          <img
                            src={contentItem.content.thumbnailUrl || ''}
                            onClick={() => openVideoModal(contentItem)}
                            className={cls(
                              "shrink-0 cursor-pointer rounded-lg bg-[#ececed] object-cover",
                              isMain ? "h-[68px] w-[120px]" : "h-[56px] w-[100px]"
                            )}
                            alt=""
                          />
                          <div className="min-w-0 grow">
                            <div className={cls(
                              "break-words font-bold leading-snug text-seq-text",
                              isMain ? "text-base" : "text-sm"
                            )}>
                              {contentItem.content.name}
                            </div>
                            {meta && <div className="mt-1 break-words text-xs leading-snug text-seq-text3">{meta}</div>}
                          </div>
                        </div>

                        {/* 디바큐잉은 프로그램 등록 화면에서 입력한다. 여기서는 보여주기만. */}
                        {isMain && (() => {
                          const qcue = getMemo(program.id, contentItem.content.id);
                          if (!qcue || !qcue.memo) return null;
                          return (
                            <div className="mt-3 border-t border-seq-borderSoft pt-2.5">
                              <div className="flex items-start space-x-2">
                                <span className="shrink-0 text-xs font-bold text-seq-text3">디바큐잉</span>
                                <span className="grow break-words text-sm leading-snug text-seq-text2">{qcue.memo}</span>
                              </div>
                            </div>
                          );
                        })()}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  }

  return (
    <>
      <Modal id="videoModal" title={`영상`}>
        <video src={videoUrl} className="border mt-5" controls />
      </Modal>
      <div className='block md:hidden lg:hidden xl:hidden 2xl:hidden'>
        {showPrint &&
          <div
            onClick={handlePrint}
            className="btn btn-md mx-2 my-4 btn-neutral px-10"
          >
            인쇄
          </div>
        }
        <div ref={componentRef} className="p-1">
          {
            (dynamicProgramDataList && dynamicProgramDataList.length > 0)?
            <>
            {
              dynamicProgramDataList.map((item:DynamicProgramDto, index:number)=>{
                console.log('item : ', item)
                //const contentIds = item.program.contentsIds.split(',');
                return (
                  <table className=" table mt-1 mb-12 border-2 border-collapse border-spacing-0 border-black text-[11px]">
                    <tbody>
                        <tr>
                          <th className=" border text-center px-1 py-1">{date || ''}</th>
                          <th className=" border text-center px-1 py-1">{item.program.programType}</th>
                          <th colSpan={2} className=" border px-1 text-center py-1">{getPartsFromDynamicProgram(item)}</th>
                          <th className=" border text-center px-1 py-1">{item.program.name}</th>
                        </tr>
                        <tr>
                          <th className=" border text-center px-1 py-1">{`${item.program.totalMotions}동작 (${item.program.totalSet}R)`}</th>
                          <th colSpan={2} className=" border px-1 text-center py-1">{getToolsFromDynamicProgram(item)}</th>
                          <th className=" border text-center px-1 py-1">{getDynamicProgramTime(item)}</th>
                          <th className=" border text-center px-1 py-1">{`${((Math.floor(item.program.totalExerciseTime/60)))}:${('0' + (Math.floor(item.program.totalExerciseTime%60))).slice(-2)}`}</th>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'커리큘럼명'}</td>
                          <td colSpan={5} className=" border px-5 py-1" >{item.program.curriculumName}</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'옵션'}</td>
                          <td colSpan={5} className=" border px-5 py-1" >{getDynamicProgramOption(item)}</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'영역'}</td>
                          <td colSpan={5} className=" border px-5 py-1" >{getDynamicProgramLayoutCount(item)}영역</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'추가운동'}</td>
                          <td colSpan={5} className=" border px-5 py-1" >{getDynamicProgramAddProgram(item)}</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'물먹는시간'}</td>
                          <td colSpan={5} className=" border px-5 py-1" >{getDynamicProgramWater(item)}</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'레이아웃'}</td>
                          <td colSpan={5} className=" border py-1" >
                            <LayoutTableItem small={true} item={getDynamicProgramLayout(item) || undefined}/>
                          </td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'수업\n코멘트'}</td>
                          <td colSpan={5} className=" border px-5 py-1" >{item.program.comment}</td>
                        </tr>
                        <tr className=" bg-black">
                          <th colSpan={2} className=" border border-white text-white text-center py-1">{'운동명'}</th>
                          <th colSpan={3} className=" border border-white text-white text-center py-1" >{'동작'}</th>
                        </tr>
                        <tr className=" bg-black">
                          <th colSpan={5} className=" border border-white text-white text-center py-1" >{'수업 코멘트'}</th>
                        </tr>
                        {
                          item.content.map((contentItem:ContentsDtoWithId, contentIndex:number)=>{
                            if(!contentItem)
                            {
                              return null
                            }

                            const toolNames = getToolsFromContent(contentItem)
                            const partNames = getPartsFromContent(contentItem)
                            
                            return (
                              <>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td className=" border text-center py-1">{toolNames || ''}</td>
                                  <td className=" border text-center py-1">{partNames || ''}</td>
                                  <td align="center" rowSpan={2} colSpan={4} className=" border bg-white p-0 m-0">
                                    <img
                                      src={contentItem.content.thumbnailUrl || ''}
                                      onClick={() => openVideoModal(contentItem)}
                                      className="w-24 object-cover"
                                      alt="program background"
                                    />
                                  </td>
                                </tr>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td colSpan={2} className=" border  text-center py-1">{contentItem.content.name}</td>
                                </tr>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td colSpan={5}   className={` ${contentItem.content.comment?'':'text-slate-300'} border py-1`}>{contentItem.content.comment?contentItem.content.comment:'코멘트 없음'}</td>
                                </tr>
                              </>
                            )
                          })
                        }
                    </tbody>
                  </table>
                )
              })
            }
            </>
            :null
          }
          {
            (programDataList && programDataList.length > 0)?
            <>
            {
              programDataList.map((item:ProgramDto, index:number)=>{

                const contentIds = item.program.contentsIds.split(',');
                const cadioList = getProgramCadioList(item.program)
                return (
                  <table className=" table mt-1 mb-12 border-2 border-collapse border-spacing-0 border-black text-[11px]">
                    <tbody>
                        <tr>
                          <th className=" border text-center px-1 py-1">{date || ''}</th>
                          <th className=" border text-center px-1 py-1">{item.program.programType}</th>
                          <th colSpan={2} className=" border px-1 text-center py-1">{getPartsFromProgram(item)}</th>
                          <th className=" border text-center px-1 py-1">{item.program.name}</th>
                        </tr>
                        <tr>
                          <th className=" border text-center px-1 py-1">{`${item.program.totalMotions}동작 (${item.program.totalSet}R)`}</th>
                          <th colSpan={2} className=" border px-1 text-center py-1">{getToolsFromProgram(item)}</th>
                          <th className=" border text-center px-1 py-1">{`${item.program.exerciseTime}/${item.program.moveTime}`}</th>
                          <th className=" border text-center px-1 py-1">{`${((Math.floor(item.program.totalExerciseTime/60)))}:${('0' + (Math.floor(item.program.totalExerciseTime%60))).slice(-2)}`}</th>
                        </tr>
                        {
                          item.program.programType == '본운동'?
                          <tr>
                            <td className=" border text-center py-1">{'유산소\n미리보기'}</td>
                            <td colSpan={5} className=" border px-1 py-1" >
                              
                              <div className="flex">
                                {
                                  cadioList.map((cadioItem:string, cadioIndex:number)=>{
                                    return (
                                      <div className="ml-[2px] items-center">
                                        <div className=" text-center m-0 text-[6px]">{cadioIndex +1}</div>
                                        {
                                          cadioItem == 'FREE'?
                                          <div className={` w-[6px] h-4 bg-[#00C7F2]`}/>
                                          :
                                          cadioItem == 'ROLL-UP'?
                                          <div className={` w-[6px] h-4 bg-[#FE06F2]`}/>
                                          :
                                          cadioItem == 'ALL-OUT'?
                                          <div className={` w-[6px] h-4 bg-[#FF0000]`}/>
                                          :
                                          <div className={` w-[6px] h-4 bg-[#D2D2D2]`}/>
                                        }
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </td>
                          </tr>
                          :null
                        }
                        {
                          item.program.programType == '본운동'?
                          <tr>
                            <td className=" border text-center py-1">{'FLOOR'}</td>
                            <td colSpan={5} className=" border px-5 py-1" >{item.program.floor}</td>
                          </tr>
                          :null
                        }
                        {
                          item.program.programType == '본운동'?
                          <tr>
                            <td className=" border text-center py-1">{'프로그램\n설명'}</td>
                            <td colSpan={5} className=" border px-5 py-1" >{item.program.description}</td>
                          </tr>
                          :null
                        }
                        <tr>
                          <td className=" border text-center py-1">{'수업\n코멘트'}</td>
                          <td colSpan={5} className=" border px-5 py-1" >{item.program.comment}</td>
                        </tr>
                        <tr className=" bg-black">
                          <th colSpan={2} className=" border border-white text-white text-center py-1">{'운동명'}</th>
                          <th colSpan={1} className=" border border-white text-white text-center py-1" >{'동작'}</th>
                          <th colSpan={2} className=" border border-white text-white text-center py-1" >{'세트'}</th>
                        </tr>
                        <tr className=" bg-black">
                          <th colSpan={5} className=" border border-white text-white text-center py-1" >{'수업 코멘트'}</th>
                        </tr>
                        {
                          contentIds.map((contentId:string, contentIndex:number)=>{
                            const contentItem = getContent(item, parseInt(contentId))

                            if(!contentItem)
                            {
                              return null
                            }

                            const toolNames = getToolsFromContent(contentItem)
                            const partNames = getPartsFromContent(contentItem)
                            
                            return (
                              <>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td className=" border text-center py-1">{toolNames || ''}</td>
                                  <td className=" border text-center py-1">{partNames || ''}</td>
                                  <td align="center" rowSpan={2} className=" border bg-white p-0 m-0">
                                    <img
                                      src={contentItem.content.thumbnailUrl || ''}
                                      onClick={() => openVideoModal(contentItem)}
                                      className="w-24 object-cover"
                                      alt="program background"
                                    />
                                  </td>
                                  <td rowSpan={2} colSpan={2} className={` border text-center py-1`}>
                                    <div>
                                      {
                                        (contentItem.sets && contentItem.sets.length > 0)?
                                        contentItem.sets.map((setItem)=>{
                                          return (<div>{setItem}</div>)
                                        })
                                        :null
                                      }
                                    </div>
                                  </td>
                                </tr>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td colSpan={2} className=" border  text-center py-1">{contentItem.content.name}</td>
                                </tr>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td colSpan={5}   className={` ${contentItem.content.comment?'':'text-slate-300'} border py-1`}>{contentItem.content.comment?contentItem.content.comment:'코멘트 없음'}</td>
                                </tr>
                              </>
                            )
                          })
                        }
                    </tbody>
                  </table>
                )
              })
            }
            </>
            :null
          }
        </div>
      </div>
      <div className='hidden md:block lg:block xl:block 2xl:block'>
        {showPrint &&
          <div
            onClick={handlePrint}
            className="btn btn-md mx-10 my-4 btn-neutral px-10"
          >
            인쇄
          </div>
        }
        <div ref={componentRef} className=" p-10">
        {
            (dynamicProgramDataList && dynamicProgramDataList.length > 0)?
            <>
            {
              dynamicProgramDataList.map((item:DynamicProgramDto, index:number)=>{
                return (
                  <table className=" table my-10 border-2 border-black text-xs">
                    <tbody>
                        <tr>
                          <th className=" border text-center py-1">{date || ''}</th>
                          <th className=" border text-center py-1">{item.program.programType}</th>
                          <th className=" border text-center py-1">{getPartsFromDynamicProgram(item)}</th>
                          <th className=" border text-center py-1">{item.program.name}</th>
                          <th className=" border text-center py-1">{`${item.program.totalSet}Set`}</th>
                          <th className=" border text-center py-1">{getToolsFromDynamicProgram(item)}</th>
                          <th className=" border text-center py-1">{`${item.program.exerciseTime}/${item.program.moveTime}`}</th>
                          <th className=" border text-center py-1">{`${((Math.floor(item.program.totalExerciseTime/60)))}:${('0' + (Math.floor(item.program.totalExerciseTime%60))).slice(-2)}`}</th>
                        </tr>
                        {
                          Number(brandId) == 3?
                          <tr>
                            <td className=" border text-center py-1">{'BPM'}</td>
                            <td colSpan={7} className=" border px-5 py-1" >{item.program.bpm} BPM<br></br><br></br>{item.program.bpmInfo}</td>
                          </tr>
                          :null
                        }
                        <tr>
                          <td className=" border text-center py-1">{'커리큘럼명'}</td>
                          <td colSpan={7} className=" border px-5 py-1" >{item.program.curriculumName}</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'옵션'}</td>
                          <td colSpan={7} className=" border px-5 py-1" >{getDynamicProgramOption(item)}</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'영역'}</td>
                          <td colSpan={7} className=" border px-5 py-1" >{getDynamicProgramLayoutCount(item)}영역</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'추가운동'}</td>
                          <td colSpan={7} className=" border px-5 py-1" >{getDynamicProgramAddProgram(item)}</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'물먹는 시간'}</td>
                          <td colSpan={7} className=" border px-5 py-1" >{getDynamicProgramWater(item)}</td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'레이아웃'}</td>
                          <td colSpan={7} className=" border px-5 py-1" >
                            <LayoutTableItem item={getDynamicProgramLayout(item) || undefined}/>
                          </td>
                        </tr>
                        <tr>
                          <td className=" border text-center py-1">{'수업\n코멘트'}</td>
                          <td colSpan={7} className=" border px-5 py-1" >{item.program.comment}</td>
                        </tr>
                        <tr className=" bg-black">
                          <th colSpan={2} className=" border border-white text-white text-center py-1">{'운동명'}</th>
                          <th className=" border border-white text-white text-center py-1" >{'동작'}</th>
                          <th colSpan={5} className=" border border-white text-white text-center py-1" >{'수업 코멘트'}</th>
                        </tr>
                        {
                          item.content.map((contentItem:ContentsDtoWithId, contentIndex:number)=>{
                            if(!contentItem)
                            {
                              return null
                            }

                            const toolNames = getToolsFromContent(contentItem)
                            const partNames = getPartsFromContent(contentItem)
                            
                            return (
                              <>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td className=" border text-center py-1">{toolNames || ''}</td>
                                  <td className=" border text-center py-1">{partNames || ''}</td>
                                  <td align="center" rowSpan={2} className=" border bg-white p-0 m-0">
                                    <img
                                      src={contentItem.content.thumbnailUrl || ''}
                                      className="w-24 object-cover"
                                      alt="program background"
                                      onClick={() => openVideoModal(contentItem)}
                                    />
                                  </td>
                                  <td rowSpan={2} colSpan={5}  className=" border py-1">{contentItem.content.comment}</td>
                                </tr>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td colSpan={2} className=" border  text-center py-1">{contentItem.content.name}</td>
                                </tr>
                              </>
                            )
                          })
                        }
                    </tbody>
                  </table>
                )
              })
            }
            </>
            :null
          }
          {
            (programDataList && programDataList.length > 0)?
            <>
            {
              programDataList.map((item:ProgramDto, index:number)=>{
                
                const contentIds = item.program.contentsIds.split(',');
                const cadioList = getProgramCadioList(item.program)
                return (
                  <table className=" table my-10 border-2 border-black text-xs">
                    <tbody>
                        <tr>
                          <th className=" border text-center py-1">{date || ''}</th>
                          <th className=" border text-center py-1">{item.program.programType}</th>
                          <th className=" border text-center py-1">{getPartsFromProgram(item)}</th>
                          <th className=" border text-center py-1">{item.program.name}</th>
                          <th className=" border text-center py-1">{`${item.program.totalMotions}동작 (${item.program.totalSet}R)`}</th>
                          <th className=" border text-center py-1">{getToolsFromProgram(item)}</th>
                          <th className=" border text-center py-1">{`${item.program.exerciseTime}/${item.program.moveTime}`}</th>
                          <th className=" border text-center py-1">{`${((Math.floor(item.program.totalExerciseTime/60)))}:${('0' + (Math.floor(item.program.totalExerciseTime%60))).slice(-2)}`}</th>
                        </tr>
                        {
                          item.program.programType == '본운동'?
                          <tr>
                            <td className=" border text-center py-1">{'유산소\n미리보기'}</td>
                            <td colSpan={7} className=" border px-5 py-1" >
                              
                              <div className="flex">
                                {
                                  cadioList.map((cadioItem:string, cadioIndex:number)=>{
                                    return (
                                      <div className="ml-2 items-center">
                                        <div className=" text-center text-xs">{cadioIndex +1}</div>
                                        {
                                          cadioItem == 'FREE'?
                                          <div className={` w-4 h-7 bg-[#00C7F2]`}/>
                                          :
                                          cadioItem == 'ROLL-UP'?
                                          <div className={` w-4 h-7 bg-[#FE06F2]`}/>
                                          :
                                          cadioItem == 'ALL-OUT'?
                                          <div className={` w-4 h-7 bg-[#FF0000]`}/>
                                          :
                                          <div className={` w-4 h-7 bg-[#D2D2D2]`}/>
                                        }
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </td>
                          </tr>
                          :null
                        }
                        {
                          item.program.programType == '본운동'?
                          <tr>
                            <td className=" border text-center py-1">{'FLOOR'}</td>
                            <td colSpan={7} className=" border px-5 py-1" >{item.program.floor}</td>
                          </tr>
                          :null
                        }
                        {
                          item.program.programType == '본운동'?
                          <tr>
                            <td className=" border text-center py-1">{'프로그램\n설명'}</td>
                            <td colSpan={7} className=" border px-5 py-1" >{item.program.description}</td>
                          </tr>
                          :null
                        }
                        <tr>
                          <td className=" border text-center py-1">{'수업\n코멘트'}</td>
                          <td colSpan={7} className=" border px-5 py-1" >{item.program.comment}</td>
                        </tr>
                        <tr className=" bg-black">
                          <th colSpan={2} className=" border border-white text-white text-center py-1">{'운동명'}</th>
                          <th className=" border border-white text-white text-center py-1" >{'동작'}</th>
                          <th className=" border border-white text-white text-center py-1" >{'세트'}</th>
                          <th colSpan={5} className=" border border-white text-white text-center py-1" >{'수업 코멘트'}</th>
                        </tr>
                        {
                          contentIds.map((contentId:string, contentIndex:number)=>{
                            const contentItem = getContent(item, parseInt(contentId))

                            if(!contentItem)
                            {
                              return null
                            }

                            const toolNames = getToolsFromContent(contentItem)
                            const partNames = getPartsFromContent(contentItem)
                            
                            return (
                              <>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td className=" border text-center py-1">{toolNames || ''}</td>
                                  <td className=" border text-center py-1">{partNames || ''}</td>
                                  <td align="center" rowSpan={2} className=" border bg-white p-0 m-0">
                                    <img
                                      src={contentItem.content.thumbnailUrl || ''}
                                      className="w-24 object-cover"
                                      alt="program background"
                                      onClick={() => openVideoModal(contentItem)}
                                    />
                                  </td>
                                  <td rowSpan={2} className={` border text-center py-1`}>
                                    <div>
                                      {
                                        (contentItem.sets && contentItem.sets.length > 0)?
                                        contentItem.sets.map((setItem)=>{
                                          return (<div>{setItem}</div>)
                                        })
                                        :null
                                      }
                                    </div>
                                  </td>
                                  <td rowSpan={2} colSpan={5}  className=" border py-1">{contentItem.content.comment}</td>
                                </tr>
                                <tr className={contentIndex%2 == 0?' bg-white':' bg-gray-100'}>
                                  <td colSpan={2} className=" border  text-center py-1">{contentItem.content.name}</td>
                                </tr>
                              </>
                            )
                          })
                        }
                    </tbody>
                  </table>
                )
              })
            }
            </>
            :null
          }
        </div>
      </div>
    </>
  );
}
